// @flow
import { createSelector } from 'reselect';
import { fromJS } from 'immutable';

export const getAlerts = (state: { alerts: typeof fromJS }) => state.alerts || fromJS({});

export const getAlertItems = createSelector([getAlerts], alerts => alerts.get('alertItems', fromJS([])));

export const getAlertById = createSelector([getAlertItems, (state, id) => id], (alertItems, id) =>
    alertItems.find(alert => alert.get('id') === id)
);



// WEBPACK FOOTER //
// ./src/core/state/alerts/selectors.js